import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
const BUYERS = [{
  name: 'Sarah M.',
  location: 'California'
}, {
  name: 'David L.',
  location: 'Texas'
}, {
  name: 'Emma R.',
  location: 'New York'
}, {
  name: 'James K.',
  location: 'Florida'
}, {
  name: 'Sofia P.',
  location: 'Illinois'
}, {
  name: 'Michael T.',
  location: 'Ohio'
}, {
  name: 'Isabella G.',
  location: 'Georgia'
}, {
  name: 'Daniel W.',
  location: 'Washington'
}, {
  name: 'Olivia H.',
  location: 'Colorado'
}, {
  name: 'Lucas B.',
  location: 'Arizona'
}, {
  name: 'Mia C.',
  location: 'Virginia'
}, {
  name: 'Ethan F.',
  location: 'Oregon'
}];
const PRODUCTS = ['the Pro Kit!', 'the Essential Kit!'];
const TIMES = ['Just now', '2 minutes ago', '5 minutes ago', '12 minutes ago'];
export function SocialProofToast() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [productIndex, setProductIndex] = useState(0);
  const [timeIndex, setTimeIndex] = useState(0);
  useEffect(() => {
    // Initial delay before showing the first toast
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 2000);
    // Set up the rotation cycle (show for 4s, hide for 4s = 8s total)
    const interval = setInterval(() => {
      setIsVisible(prev => {
        if (!prev) {
          // When becoming visible, pick new random data
          setCurrentIndex(Math.floor(Math.random() * BUYERS.length));
          setProductIndex(Math.floor(Math.random() * PRODUCTS.length));
          setTimeIndex(Math.floor(Math.random() * TIMES.length));
          return true;
        }
        return false;
      });
    }, 4000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const currentBuyer = BUYERS[currentIndex];
  const currentProduct = PRODUCTS[productIndex];
  const currentTime = TIMES[timeIndex];
  return <AnimatePresence data-id="element-255">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 w-full max-w-xs bg-white rounded-2xl shadow-2xl border border-dark/10 p-4 flex items-start gap-3" data-id="element-256">
          <div className="flex-shrink-0 mt-1" data-id="element-257">
            <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary font-bold text-lg" data-id="element-258">
              {currentBuyer.name.charAt(0)}
            </div>
          </div>

          <div className="flex-grow pr-4" data-id="element-259">
            <p className="text-sm text-dark leading-tight mb-1" data-id="element-260">
              <span className="font-bold" data-id="element-261">{currentBuyer.name}</span> from{' '}
              {currentBuyer.location} just purchased {currentProduct}
            </p>
            <div className="flex items-center gap-1.5 text-xs text-muted font-medium" data-id="element-262">
              <CheckCircle2 className="w-3.5 h-3.5 text-success" data-id="element-263" />
              <span data-id="element-264">Verified Buyer • {currentTime}</span>
            </div>
          </div>

          <button onClick={() => setIsVisible(false)} className="absolute top-3 right-3 text-muted hover:text-dark transition-colors" aria-label="Close notification" data-id="element-265">
            <X className="w-4 h-4" data-id="element-266" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}